import React, { useState } from "react"
import { ICategory } from "../../../../gatsby-graphql"
import {
  ActiveCategory,
  Dropdown,
  DropdownWrapper,
} from "./categories-dropdown-elements"
import { CategoryLink } from "../categories-bar-elements"
import { DropdownMarker } from "../../../ui"

interface CategoriesDropdownProps {
  data: ICategory[]
  basePath: string
  active?: string | null
  onClick?: (
    event: React.MouseEvent<HTMLAnchorElement>,
    categorySlug: string | null
  ) => void
}

const CategoriesDropdown = ({
  data,
  basePath,
  active,
  onClick,
}: CategoriesDropdownProps) => {
  active = active || null
  const activeCategory = data.find(category => category.slug === active)
  const [visible, setVisible] = useState<boolean>(false)

  return (
    <DropdownWrapper>
      <ActiveCategory onClick={() => setVisible(!visible)}>
        {activeCategory?.name} <DropdownMarker />
      </ActiveCategory>
      {visible && (
        <Dropdown>
          {data.map(category => {
            if (category.slug === active) {
              return null;
            }
            return (
              <CategoryLink
                key={category.slug}
                to={`${basePath}${category.slug || ""}`}
                onClick={e => {
                  setVisible(false)
                  if (onClick) onClick(e, category.slug || null)
                }}
              >
                {category.name}
              </CategoryLink>
            )
          })}
        </Dropdown>
      )}
    </DropdownWrapper>
  )
}

export default CategoriesDropdown
